'use client';

import { type FC } from 'react';
import { ScreenContent } from '../../../screen';
import { Button } from '../../ui';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';

/** Fatal runtime-error screen for Rush Mid (bad join / lost connection). With `onTopUp`
 *  (insufficient balance) the primary action leads to the payment screen instead. */
export const RushMidErrorScreen: FC<{ message: string; onBack: () => void; onTopUp?: () => void }> = ({ message, onBack, onTopUp }) => {
  const { t } = useLocalTranslation(translations);
  return (
    <ScreenContent hideLegalSection scrollKey="rush-mid-runtime-error">
      <div className="flex min-h-full flex-col items-center justify-center gap-4 px-8 text-center">
        <div className="text-base font-semibold text-label-primary">{t('errorTitle')}</div>
        <div className="text-sm text-label-secondary">{message}</div>
        <div className="flex w-full max-w-xs flex-col gap-2">
          {onTopUp && <Button variant="primary" size="l" stretched onClick={onTopUp}>{t('topUpBalance')}</Button>}
          <Button variant={onTopUp ? 'secondary' : 'primary'} size="l" stretched onClick={onBack}>{t('backToLobby')}</Button>
          {!onTopUp && <Button variant="tertiary" size="l" stretched onClick={() => window.location.reload()}>{t('reloadScreen')}</Button>}
        </div>
      </div>
    </ScreenContent>
  );
};
